import celebrationImg from './assets/celebration.png';
import highfiveImg from './assets/highfive.png';
import ribbonImg from './assets/ribbon.png';
import trophyImg from './assets/trophy.png';
import wreathImg from './assets/wreath.png';

export interface LessonCompletePresetImage {
  id: string;
  label: string;
  src: string;
}

export const LESSON_COMPLETE_PRESET_IMAGES: readonly LessonCompletePresetImage[] = [
  { id: 'celebration', label: 'Celebration', src: celebrationImg },
  { id: 'highfive', label: 'High Five', src: highfiveImg },
  { id: 'ribbon', label: 'Ribbon', src: ribbonImg },
  { id: 'trophy', label: 'Trophy', src: trophyImg },
  { id: 'wreath', label: 'Wreath', src: wreathImg },
];
